import { schema } from 'normalizr';
import dataSetSchema from './dataSet';
import sourceSchema from './source';
import sinkSchema from './sink';
import credentialSchema from './credential';
import usersSchema from './user';
import orgsSchema from './org';

const recordLineageSchema = new schema.Values(
  {
    output: {
      data_sets: [dataSetSchema],
      data_sources: [sourceSchema],
      data_sinks: [sinkSchema],
      data_credentials: [credentialSchema],
      users: [usersSchema],
      orgs: [orgsSchema],
    },
  },
  (value, parent, key) => {
    return key;
  },
);

export default recordLineageSchema;
